import React from 'react';
import { withScriptjs, withGoogleMap, Marker } from 'react-google-maps';
import { compose, withProps, withStateHandlers, withHandlers, lifecycle } from 'recompose';
import GoogleMapComponent from './GoogleMapComponent';
import conf from '../../conf';


function componentWillMount() {
  const { studioData } = this.props;
  if (studioData.length > 0) {
    this.setState({
      zoomToMarkers: (map) => {
        const bounds = new window.google.maps.LatLngBounds();
        let count = 0;
        let data = {};
        const delta = 0.01;
        map.props.children.forEach((child, i) => {
          if (child.type === Marker) {
            bounds.extend(new window.google.maps
              .LatLng(Number(studioData[i].latitude), Number(studioData[i].longitude)));
            count++;
            if (count < 2) {
              data = {'latitude': Number(studioData[i].latitude), 'longitude': Number(studioData[i].longitude)};
            }
          }
        });
        if (1 === count) {
          bounds.extend(new window.google.maps
              .LatLng(data.latitude - delta, data.longitude - delta));
          bounds.extend(new window.google.maps
              .LatLng(data.latitude + delta, data.longitude + delta));
        }
        map.fitBounds(bounds);
      },

    });
  }
}

const enhance = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${conf.googleMapToken}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '100%' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withStateHandlers(() => ({
    openInfoWindowMarkerId: null,
  }), {
    showMarker: state => markerId => ({
      ...state,
      openInfoWindowMarkerId: markerId,
    }),
    hideMarker: state => () => ({
      ...state,
      openInfoWindowMarkerId: null,
    }),
  }),
  withHandlers({
    onToggleOpen: props => markerId => () => {
      if (props.openInfoWindowMarkerId === markerId) {
        props.hideMarker();
      } else {
        props.showMarker(markerId);
      }
    },
  }),
  lifecycle({
    componentWillMount,
  }),
  withScriptjs,
  withGoogleMap,
);

export default enhance(GoogleMapComponent);



// WEBPACK FOOTER //
// src/components/googleMap/GoogleMapContainer.jsx